import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';
import type { RequireCustomerTipPageProps } from './components/RequireCustomerTipPageContent';

const RequireCustomerTipPageContent = lazy(
  () => import('./components/RequireCustomerTipPageContent'),
);

export const RequireCustomerTipPage = wrapLazyNavigatorScreen(
  (props: RequireCustomerTipPageProps) => {
    return <RequireCustomerTipPageContent {...props} />;
  },
  {
    headerShown: false,
  },
);
